module.exports = {
    RECEIVE_ARRESTS: 'RECEIVE_ARRESTS',
}
